import React from 'react';
import CommentBody from '@wix/da-shared-react/pkg/Comment/_partials/CommentBody';
import CommentContextProvider from '@wix/da-shared-react/pkg/Comment/_partials/CommentContext';
import DeviationDumbView from '@wix/da-shared-react/pkg/DeviationViews/Dumbo';
import { PapiComment, PapiDeviation } from '@wix/da-types-papi';
import { isImageDeviation } from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import s from './MyComment.scss';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';
import Timestamp from '@wix/da-shared-react/pkg/Timestamp';

export interface Props {
  className?: string;
  title: React.ReactNode;
  comment: PapiComment;
  thumb?: PapiDeviation;
  isMobile?: boolean;
}

export class MyComment extends React.Component<Props> {
  render() {
    return (
      <div className={s['root']}>
        <div className={s['comment']}>
          {this.renderCommentHeader()}
          {this.renderCommentBody()}
          {this.renderTimestamp()}
        </div>
        {this.renderThumb()}
      </div>
    );
  }

  renderCommentHeader() {
    return <div className={s['header']}>{this.props.title}</div>;
  }

  renderCommentBody() {
    const { comment } = this.props;
    return (
      <CommentContextProvider comment={comment}>
        <div className={s['body']}>
          <CommentBody />
        </div>
      </CommentContextProvider>
    );
  }

  renderTimestamp() {
    return (
      <div className={s['timestamp']}>
        <Timestamp timestamp={this.props.comment.posted} />
      </div>
    );
  }

  renderThumb() {
    const { thumb, isMobile } = this.props;
    if (!thumb || !isImageDeviation(thumb)) {
      return null;
    }
    return (
      <div className={s['deviation']}>
        <DeviationDumbView
          deviation={thumb}
          width={isMobile ? 87 : 174}
          height={isMobile ? 80 : 128}
          className={s['thumb']}
        />
      </div>
    );
  }
}

export default withMobileContext(MyComment);
